var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tr", { staticClass: "concordance" }, [
    _c("td", { attrs: { colspan: "10" } }, [
      _c(
        "div",
        { staticClass: "well-light" },
        [
          _c("div", { staticClass: "concordance-controls clearfix" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-primary open-concordances",
                attrs: { type: "button", disabled: _vm.disabled },
                on: {
                  click: function ($event) {
                    return _vm.$emit("openFullConcordances")
                  },
                },
              },
              [
                _c("span", { staticClass: "fa fa-angle-double-left" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("results.table.viewDetailedConcordances"))
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.concordances.done
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-default",
                    attrs: {
                      type: "button",
                      disabled: _vm.concordances.loading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.concordances.next()
                      },
                    },
                  },
                  [
                    _vm.concordances.loading
                      ? [
                          _c("span", { staticClass: "fa fa-spin fa-spinner" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("results.table.loading")) +
                              "\n\t\t\t\t\t"
                          ),
                        ]
                      : [
                          _vm._v(
                            _vm._s(_vm.$t("results.table.loadMoreConcordances"))
                          ),
                        ],
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close close-concordances",
                attrs: { type: "button", title: "close" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_c("span", [_vm._v("×")])]
            ),
          ]),
          _vm._v(" "),
          _vm.concordances.error != null
            ? _c("div", {
                staticClass: "text-danger",
                domProps: { innerHTML: _vm._s(_vm.concordances.error) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "hits" && _vm.concordances.results.length
            ? _c("HitsTable", {
                attrs: {
                  data: _vm.concordances.results,
                  mainAnnotation: _vm.mainAnnotation,
                  dir: _vm.dir,
                  html: _vm.html,
                },
              })
            : _vm.type === "docs" && _vm.concordances.results.length
            ? _c("DocsTable", {
                attrs: {
                  mainAnnotation: _vm.mainAnnotation,
                  metadata: _vm.metadata,
                  dir: _vm.dir,
                  html: _vm.html,
                  data: _vm.concordances.results,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.concordances.results.length > 10
            ? _c("div", { staticClass: "concordance-controls clearfix" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary open-concordances",
                    attrs: { type: "button", disabled: _vm.disabled },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("openFullConcordances")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "fa fa-angle-double-left" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("results.table.viewDetailedConcordances"))
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.concordances.done
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-default",
                        attrs: {
                          type: "button",
                          disabled: _vm.concordances.loading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.concordances.next()
                          },
                        },
                      },
                      [
                        _vm.concordances.loading
                          ? [
                              _c("span", {
                                staticClass: "fa fa-spin fa-spinner",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("results.table.loading")) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("results.table.loadMoreConcordances")
                                )
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close close-concordances",
                    attrs: {
                      type: "button",
                      title: _vm.$t("results.table.close").toString(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_c("span", [_vm._v("×")])]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }